<template>
  <section>
    <v-footer app class="pt-3 d-print-none">
      <v-btn x-large @click.prevent="regresar" class="mr-5"
        ><v-icon>chevron_left</v-icon> Regresar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!esVisualizacion"
        class="mr-5"
        text
        @click.prevent="lecturaManual"
        ><v-icon>add</v-icon> Lectura Manual</v-btn
      >
      <v-btn
        color="primary"
        v-if="(muestraEstatusID === 5 && !editando) || esVisualizacion"
        x-large
        class="mr-2"
        @click.prevent="imprimir"
        ><v-icon>print</v-icon> Imprimir
      </v-btn>
      <v-btn
        color="primary"
        v-if="muestraEstatusID === 5 && !editando"
        x-large
        @click.prevent="editar"
        ><v-icon>edit</v-icon> Editar
      </v-btn>
      <v-btn
        color="primary"
        v-if="
          gradillas.length &&
            gradillas[0].Muestras.length &&
            (!esVisualizacion || esValidacion)
        "
        x-large
        @click.prevent="guardar"
        ><v-icon>save</v-icon> Guardar
      </v-btn>
    </v-footer>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex xs10>
            <span class="text-h4" v-if="pcrID"> PCR Folio: {{ pcrID }} </span>
            <v-tabs
              v-show="false"
              background-color="transparent"
              v-model="tab"
              class="transparent"
            >
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab v-for="(g, i) in gradillas" :key="g.GradillaID">
                {{ esPCR ? "PCR" : i + 1 }} - {{ g.NumeroFilas }} x
                {{ g.NumeroColumnas }}
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-flex xs2 class="text-right pt-2">
            <v-autocomplete
              v-if="esPCR && !esVisualizacion"
              label="Kit a utilizar"
              :items="catalogos.Kits"
              v-model="kit"
              item-text="Nombre"
              item-value="KitID"
            >
            </v-autocomplete>
            <span class="text-h4" v-if="esVisualizacion">
              Kit:
              {{
                catalogos.Kits.length && kit
                  ? catalogos.Kits.find((k) => k.KitID === kit).Nombre
                  : "-"
              }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout v-if="gradillas.length">
          <v-layout row :style="colWidth">
            <v-flex xs12>
              <div
                :class="{
                  hover: posicionMouse.Fila === r - 1,
                }"
                class="text-center ma-2  font-weight-bold letras"
                v-for="r in gradillas[tab].NumeroFilas + 1"
                :key="r"
              >
                {{ r > 1 ? letras[r - 2] : "-" }}
              </div>
            </v-flex>
          </v-layout>
          <v-layout
            row
            v-for="c in gradillas[tab].NumeroColumnas"
            :key="c"
            :style="colWidth"
          >
            <v-flex xs12>
              <div
                :class="{
                  hover: posicionMouse.Columna === c,
                }"
                class="ma-1 text-center font-weight-bold columna"
              >
                {{ c }}
              </div>
              <div
                :class="{
                  hover:
                    false &&
                    (posicionMouse.Fila === r || posicionMouse.Columna === c) &&
                    r <= posicionMouse.Fila &&
                    c <= posicionMouse.Columna,
                }"
                class="text-center ma-2 posicion"
                v-for="r in gradillas[tab].NumeroFilas"
                :key="r"
                @click.prevent="clickPosicion($event, r, c)"
                @mouseover="mouseover(r, c)"
              >
                <template
                  v-if="
                    r === posicionActual.Fila && c === posicionActual.Columna
                  "
                  ><v-progress-circular
                    :size="20"
                    color="primary"
                    indeterminate
                  ></v-progress-circular
                  ><br />
                  Lea el código
                </template>
                <template v-else-if="muestrasDict[r + '-' + c]">
                  <v-badge
                    offset-x="10"
                    bottom
                    color="primary"
                    :value="
                      !!muestrasDict[r + '-' + c].esRepeticion ||
                        !!muestrasDict[r + '-' + c].esCambioManual
                    "
                    :content="getBadgeContent(muestrasDict[r + '-' + c])"
                  >
                    <span
                      v-if="!!muestrasDict[r + '-' + c].Error"
                      class="error--text"
                    >
                      <v-tooltip color="error" bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-icon color="error">close</v-icon><br />

                            <span class="codigo">
                              {{ muestrasDict[r + "-" + c].Codigo }}
                            </span>
                          </div></template
                        >
                        <span>Muestra en posición incorrecta</span>
                      </v-tooltip>
                    </span>
                    <span v-else>
                      <v-icon v-if="!esVisualizacion" color="success"
                        >check</v-icon
                      >
                      <span
                        v-else-if="!esPCR"
                        style="line-height: 23px;"
                        class="font-weight-bold"
                        >{{ c > 3 ? "Pre-PCR" : "PCR" }}</span
                      >
                      <span
                        style="line-height: 23px;"
                        class="font-weight-bold"
                        v-else-if="muestraEstatusID !== 5"
                      >
                        <span
                          :class="{
                            'error--text':
                              muestrasDict[r + '-' + c].PCRInterpretacionID ===
                              2,
                          }"
                        >
                          {{ muestrasDict[r + "-" + c].Interpretacion }}
                        </span>
                      </span>
                      <br />
                      <span class="codigo">
                        {{ muestrasDict[r + "-" + c].CodigoBarras }}
                      </span>
                    </span>
                  </v-badge>
                </template>
                <template v-else-if="c === 1 && (r === 1 || r === 2)">
                  <div
                    style="
  line-height: 50px;"
                  >
                    <span
                      class="gris--text font-weight-bold text-h3"
                      v-if="r === 1"
                      >C+</span
                    >
                    <span class="gris--text font-weight-bold text-h3" v-else
                      >C-</span
                    >
                  </div>
                </template>
                <template v-else-if="posicionActiva(r, c)">
                  <div
                    style="
  line-height: 50px;"
                  >
                    <v-icon color="gris2">add_circle</v-icon>
                  </div>
                </template>
                <template v-else>
                  <div
                    style="
  line-height: 50px;"
                  >
                    <v-icon color="gris2">block</v-icon>
                  </div>
                </template>
              </div>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-dialog v-model="mostrarLecturaGradilla" width="30%" persistent>
        <v-card>
          <v-card-title class="text-h3 primary--text"
            >AGREGAR GRADILLA</v-card-title
          >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <img
                    src="../../assets/codigobarras.png"
                    style="width: 100%; height: auto;"
                  />
                </v-flex>
                <v-flex xs12 class="text-center text-h3" v-if="!codigoManual">
                  LEA EL CODIGO DE BARRAS
                </v-flex>
                <v-flex xs12 v-else>
                  <v-form
                    ref="formGradilla"
                    @submit.prevent="verificarCodigoGradilla"
                  >
                    <v-text-field
                      :rules="[() => !!codigoBarras || 'Ingrese un valor']"
                      v-model="codigoBarras"
                      label="Código de barras"
                      autofocus
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              plain
              @click.native="codigoManual = true"
              v-if="!codigoManual"
              >Ingreso manual</v-btn
            >
            <v-btn plain @click.prevent="cancelarLectura">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-menu
      v-model="showMenu"
      :position-x="menuX"
      :position-y="menuY"
      absolute
      offset-y
      style="max-width: 600px"
    >
      <v-list>
        <v-list-item
          v-if="muestraEstatusID === 6"
          link
          @click.prevent="abrirCambioResultado"
        >
          <v-list-item-title link>Cambiar Resultado</v-list-item-title>
        </v-list-item>
        <v-list-item link @click.prevent="verMuestra">
          <v-list-item-title link>Info Muestra</v-list-item-title>
        </v-list-item>
        <v-list-item link class="error--text" v-if="!esVisualizacion">
          <v-list-item-title class="error--text" @click.prevent="removerMuestra"
            >Remover Muestra</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog width="30%" v-model="mostrarMuestra">
      <v-card>
        <v-card-title class="text-h3 primary--text">
          Info. Muestra
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md v-if="infoMuestra">
            <v-layout row wrap>
              <v-flex xs4 class="text-right font-weight-bold">
                Código Muestra:
              </v-flex>
              <v-flex xs8> {{ infoMuestra.CodigoBarras }} </v-flex>
              <v-flex xs4 class="text-right font-weight-bold">
                Fecha Toma:
              </v-flex>
              <v-flex xs8> {{ fechaSQL(infoMuestra.FechaToma) }} </v-flex>
              <v-flex xs4 class="text-right font-weight-bold">
                Hora Toma:
              </v-flex>
              <v-flex xs8> {{ horaSQL(infoMuestra.FechaToma) }} </v-flex>
              <v-flex xs4 class="text-right font-weight-bold">
                Es Repetición:
              </v-flex>
              <v-flex xs8>
                {{ infoMuestra.EsRepeticion ? "SI" : "NO" }}
              </v-flex>
              <v-flex xs4 class="text-right font-weight-bold">
                Estatus:
              </v-flex>
              <v-flex xs8> {{ infoMuestra.Estatus }} </v-flex>
              <v-flex xs4 class="text-right font-weight-bold">
                Estado Muestra:
              </v-flex>
              <v-flex xs8> {{ infoMuestra.MuestraEstado }} </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="40%" v-model="mostarCambioResultado" persistent>
      <v-card>
        <v-card-title class="text-h3 primary--text">
          Cambiar Resultado
        </v-card-title>
        <v-card-text>
          <v-form ref="formCambio">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs4 class="text-right font-weight-bold">
                  Código Muestra:
                </v-flex>
                <v-flex xs8> {{ muestraACambiar.CodigoBarras }} </v-flex>
                <v-flex xs4 class="mt-4 text-right font-weight-bold">
                  Interpretación:
                </v-flex>
                <v-flex xs8>
                  <v-autocomplete
                    hide-details="auto"
                    :items="catalogos.Interpretaciones"
                    item-value="PCRInterpretacionID"
                    item-text="Interpretacion"
                    v-model="muestraACambiar.PCRInterpretacionID"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs4 class="mt-4 text-right font-weight-bold">
                  FAM:
                </v-flex>
                <v-flex xs8>
                  <v-text-field
                    hide-details="auto"
                    type="number"
                    v-model="muestraACambiar.FAM"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="mr-5"
            text
            @click.native="mostarCambioResultado = false"
          >
            Cancelar</v-btn
          >
          <v-spacer> </v-spacer>
          <v-btn color="primary" @click.prevent="guardarCambioResultado"
            ><v-icon>save</v-icon> Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <lector-codigos
      :desactivado="mostrarLecturaManual"
      @codigoLeido="codigoLeido"
    ></lector-codigos>
    <codigo-manual
      v-if="mostrarLecturaManual"
      @cerrar="cerrarLecturaManual"
    ></codigo-manual>
  </section>
</template>

<script>
import ServicioLaboratorio from "../../services/laboratorio";
import ServicioCatalogos from "../../services/catalogos";
import LectorCodigos from "../../components/LectorCodigos.vue";
import CodigoManual from "../../components/CodigoManual.vue";
export default {
  components: { LectorCodigos, CodigoManual },
  name: "CargaGradillas",
  data() {
    return {
      infoMuestra: null,
      mostrarLecturaManual: false,
      tab: 0,
      codigoManual: false,
      mostrarLecturaGradilla: false,
      codigoBarras: "",
      gradillas: [],
      letras: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),
      mostarCambioResultado: false,
      posicionActual: {
        Fila: 1,
        Columna: 1,
      },
      posicionMouse: {
        Fila: -1,
        Columna: -1,
      },
      showMenu: false,
      menuX: 0,
      menuY: 0,
      muestraSeleccionada: null,
      tipoExtraccion: null,
      mostrarMuestra: false,
      catalogos: {
        Kits: [],
      },
      kit: null,
      muestraACambiar: {},
      editando: false,
    };
  },
  methods: {
    imprimir() {
      window.print();
    },
    editar() {
      this.editando = true;
    },
    getBadgeContent(muestra) {
      let res = "";
      if (muestra.esRepeticion) {
        res += "R";
      }
      if (muestra.esCambioManual) {
        res += !!res ? ",C" : "C";
      }
      return res;
    },
    guardarCambioResultado() {
      if (this.$refs.formCambio.validate()) {
        const muestra = this.gradillas[0].Muestras.find(
          (m) => m.CodigoBarras === this.muestraACambiar.CodigoBarras
        );
        muestra.esCambioManual = true;
        muestra.FAM = this.muestraACambiar.FAM;
        muestra.PCRInterpretacionID = this.muestraACambiar.PCRInterpretacionID;
        muestra.Interpretacion = this.catalogos.Interpretaciones.find(
          (i) => i.PCRInterpretacionID === muestra.PCRInterpretacionID
        ).Interpretacion;
        this.mostarCambioResultado = false;
      } else {
        this.$root.mensajeError = "Por favor llene todos los campos requeridos";
      }
    },
    abrirCambioResultado() {
      this.muestraACambiar = { ...this.muestraSeleccionada };
      this.mostarCambioResultado = true;
    },
    cerrarLecturaManual(codigo) {
      if (codigo) {
        this.codigoLeido(codigo);
      }
      this.mostrarLecturaManual = false;
    },
    lecturaManual() {
      this.mostrarLecturaManual = true;
    },
    async verMuestra() {
      const res = await ServicioLaboratorio.infoMuestra(
        this.muestraSeleccionada.MuestraDetalleID
      );
      this.infoMuestra = res.data.data.Table0[0];
      this.mostrarMuestra = true;
    },
    cancelarLectura() {
      this.mostrarLecturaGradilla = false;
      this.regresar();
    },
    agregarGradilla() {
      this.codigoManual = false;
      this.codigoBarras = "";
      this.mostrarLecturaGradilla = true;
    },
    verificarCodigoGradilla() {
      if (!this.codigoManual || this.$refs.formGradilla.validate()) {
        //TMP
        if (this.codigoBarras === "123456") {
          let error = "";
          if (this.esCarga) {
            error = "La gradilla se encuentra registrada en otro proceso";
          } else if (this.esExtraccion) {
            error = "La gradilla no ha sido cargada para extracción";
          }
          this.$root.mensajeError = error;

          return;
        }
        this.gradillas.push({
          GradillaID: Math.random(),
          NumeroFilas: 8,
          NumeroColumnas: 12,
          Muestras: [],
        });
        this.mostrarLecturaGradilla = false;
      }
    },
    async codigoLeido(codigo) {
      if (
        this.posicionActual.Fila === -1 ||
        this.posicionActual.Columna === -1
      ) {
        return;
      }
      if (this.gradillas[this.tab].Muestras.some((m) => m.Codigo === codigo)) {
        return (this.$root.mensajeError =
          "La muestra leida ya se encuentra en otra posición");
      }
      const res = await ServicioLaboratorio.prePCRCodigo(codigo, this.pcrID);

      if (res.data.result === 1) {
        const muestra = {
          Fila: this.posicionActual.Fila,
          Columna: this.posicionActual.Columna,
          Codigo: codigo,
          ...res.data.data.Table0[0],
        };
        this.gradillas[this.tab].Muestras.push(muestra);

        do {
          this.siguientePosicion();
        } while (
          (!!this.muestrasDict[
            this.posicionActual.Fila + "-" + this.posicionActual.Columna
          ] ||
            !this.posicionActiva(
              this.posicionActual.Fila,
              this.posicionActual.Columna
            )) &&
          this.posicionActual.Fila !== -1
        );
      } else {
        this.$root.mensajeError = res.data.message;
      }
    },
    siguientePosicion() {
      if (this.posicionActual.Fila < this.gradillas[this.tab].NumeroFilas) {
        this.posicionActual.Fila++;
      } else if (
        this.posicionActual.Columna < this.gradillas[this.tab].NumeroColumnas
      ) {
        this.posicionActual = {
          Fila: 1,
          Columna: this.posicionActual.Columna + 1,
        };
      } else {
        this.posicionActual = {
          Fila: -1,
          Columna: -1,
        };
      }
    },
    clickPosicion(e, fila, columna) {
      if (
        !this.gradillas[this.tab].Muestras.some(
          (m) => m.Fila === fila && m.Columna === columna
        ) &&
        this.posicionActiva(fila, columna)
      ) {
        this.posicionActual = {
          Fila: fila,
          Columna: columna,
        };
      } else if (
        this.gradillas[this.tab].Muestras.some(
          (m) => m.Fila === fila && m.Columna === columna
        )
      ) {
        this.muestraSeleccionada = this.gradillas[0].Muestras.find(
          (m) => m.Fila === fila && m.Columna === columna
        );
        this.menuX = e.clientX;
        this.menuY = e.clientY;
        this.$nextTick(() => (this.showMenu = true));
      }
    },
    mouseover(f, c) {
      this.posicionMouse = {
        Fila: f,
        Columna: c,
      };
    },
    async guardar() {
      if (this.hayErrores) {
        this.$root.mensajeError =
          "Por favor verifique la posición de las muestras";
        return;
      }
      if (!this.esValidacion || this.editando) {
        const muestras = this.gradillas[0].Muestras.map((m) => {
          return {
            Fila: m.Fila,
            Columna: m.Columna,
            MuestraDetalleID: m.MuestraDetalleID,
          };
        });
        const res = this.editando
          ? await ServicioLaboratorio.actualizarPrePCR(
              this.kit,
              muestras,
              this.pcrID
            )
          : await ServicioLaboratorio.guardarPrePCR(this.kit, muestras);
        if (res.data.result === 1) {
          const archivo = res.data.data.Table0[0].Archivo;
          window.open(this.config.RutaCSVPrePCR + archivo, "_blank");
          this.$root.mensajeExito = "Las muestras se procesaron exitosamente";
          this.$router.push("/digitrack/laboratorio/1");
        } else {
          this.$root.mensajeError = "Error al guardar: " + res.data.message;
        }
      } else {
        const muestrasCambiadas = this.gradillas[0].Muestras.filter(
          (m) => m.esCambioManual
        ).map((m) => {
          return {
            MuestraDetalleID: m.MuestraDetalleID,
            FAM: m.FAM,
            PCRInterpretacionID: m.PCRInterpretacionID,
          };
        });
        const res = await ServicioLaboratorio.guardarValidarPCR(
          this.pcrID,
          muestrasCambiadas
        );
        if (res.data.result === 1) {
          this.$root.mensajeExito = "Validación procesada correctamente";
          this.$router.back();
        } else {
          this.$root.mensajeError = "Error al guardar " + res.data.message;
        }
      }
    },
    regresar() {
      if (this.esValidacion || this.esResultados)
        this.$router.push("/digitrack/laboratorio/1");
      else this.$router.back();
    },
    removerMuestra() {
      this.confirmar(
        "Remover Muestra",
        "Remover muestra de la lectura actual?"
      ).then(() => {
        const ix = this.gradillas[0].Muestras.indexOf(this.muestraSeleccionada);
        this.gradillas[0].Muestras.splice(ix, 1);
      });
    },
    posicionActiva(fila, columna) {
      if (this.esVisualizacion) {
        return false;
      }
      // PCR
      if (this.esPCR) {
        if (columna === 1 && (fila === 1 || fila === 2)) {
          return false;
        }
      }
      // Simulacion de posiciones deshabilitadas (vacias)
      if (
        (this.esExtraccion || this.esPrePCR) &&
        (columna > 8 || (columna == 8 && fila > 5))
      ) {
        return false;
      }
      return true;
    },
    llenaPrueba() {
      for (let i = 1; i <= 12; i++) {
        for (let j = 1; j <= 8; j++) {
          this.codigoLeido(parseInt(Math.random() * 1000000), true);
        }
      }
    },
    async cargarCatalogos() {
      let res = await ServicioCatalogos.getKits();
      this.catalogos.Kits = res.data.data.Table0;
      res = await ServicioCatalogos.getPCRInterpretaciones();
      this.catalogos.Interpretaciones = res.data.data.Table0;
    },
  },
  async mounted() {
    await this.cargarCatalogos();
    this.kit = this.catalogos.Kits[0].KitID;
    if (this.esPCR) {
      const pcrID = this.$route.params.pcrId;
      const muestraEstatusID = this.$route.params.muestraEstatusId;
      this.gradillas.push({
        GradillaID: Math.random(),
        NumeroFilas: 8,
        NumeroColumnas: 12,
        Muestras: [],
      });
      if (!muestraEstatusID) {
        this.posicionActual = {
          Fila: 3,
          Columna: 1,
        };
      } else if (this.esValidacion) {
        this.posicionActual = {
          Fila: -1,
          Columna: -1,
        };
        const res = await ServicioLaboratorio.validacionPCR(pcrID);
        this.gradillas[0].Muestras = res.data.data.Table0;
      } else if (this.esResultados) {
        this.posicionActual = {
          Fila: -1,
          Columna: -1,
        };
        const res =
          muestraEstatusID === "5"
            ? await ServicioLaboratorio.getPrePCRResultado(pcrID)
            : await ServicioLaboratorio.resultadosPCR(pcrID);
        this.gradillas[0].Muestras = res.data.data.Table0;
        this.kit = res.data.data.Table0[0].KitID;
      }
      return;
    }
    const codigoGradilla = this.$route.params.codigoGradilla;
    if (codigoGradilla && codigoGradilla !== "0") {
      this.codigoBarras = codigoGradilla;
      this.verificarCodigoGradilla();
      if (this.esVisualizacion) {
        this.llenaPrueba();
      }
      return;
    }
    this.agregarGradilla();
  },
  computed: {
    muestrasDict() {
      if (!this.gradillas.length) return;

      return this.gradillas[this.tab].Muestras.reduce(function(r, e) {
        r[e.Fila + "-" + e.Columna] = e;
        return r;
      }, {});
    },
    colWidth() {
      return {
        width:
          String(100 / (this.gradillas[this.tab].NumeroColumnas + 1)) + "%",
      };
    },
    esCarga() {
      return this.$route.path.indexOf("carga") > -1;
    },
    esExtraccion() {
      return this.$route.path.indexOf("extraccion") > -1;
    },
    esPrePCR() {
      return this.$route.path.indexOf("pre-pcr") > -1;
    },
    esPCR() {
      return this.$route.path.indexOf("/pcr") > -1;
    },
    hayErrores() {
      return (
        this.gradillas.length && this.gradillas[0].Muestras.find((m) => m.Error)
      );
    },
    esVisualizacion() {
      return (
        (this.$route.path.indexOf("ver") > -1 ||
          (this.esPCR && !!this.$route.params.pcrId)) &&
        !this.editando
      );
    },
    muestraEstatusID() {
      return !!this.$route.params.muestraEstatusId
        ? parseInt(this.$route.params.muestraEstatusId)
        : null;
    },
    pcrID() {
      return !!this.$route.params.pcrId
        ? parseInt(this.$route.params.pcrId)
        : null;
    },
    esValidacion() {
      return this.muestraEstatusID === 6;
    },
    esResultados() {
      return this.muestraEstatusID === 7 || this.muestraEstatusID === 5;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";
.letras,
.columna {
  line-height: 50px;
}
.posicion,
.letras,
.columna {
  min-height: 60px;
}

.posicion {
  cursor: pointer;
  border: 1px dashed #dcdcdc;
}

.posicion:hover {
  background: #f3f3f3;
}
.hover {
  background: #f3f3f3;
}
.codigo {
  font-size: 12px;
  max-width: 100%;
}
.container.grid-list-md *:not(:only-child) .layout:last-child {
  margin: auto -4px !important;
}

@media #{map-get($display-breakpoints, 'print-only')} {
  .container {
    margin: 0;
  }
  .v-card__text {
    padding: 0;
  }
}
</style>
